import { change, date } from 'common/changelog';
import { emallson } from 'CONTRIBUTORS';

// prettier-ignore
export default [
  change(date(2024, 7, 5), 'Added basic Cataclysm support.', emallson),
];
